import {React, ReactDOM, _n} from 'pexui';
import {getElement} from '../../utilities/utils';

export function showSpinner(elem, opts){
    let element = getElement(elem);
    if(opts.mode === 'overlay'){
        return showOverlaySpinner(element, opts);
    }
    else if(opts.mode === 'embedded'){
        showEmbeddedSpinner(element, opts);
    }
}

export function hideSpinner(elemSpinner){
    const element = getElement(elemSpinner);
    const savedText = element.getAttribute('data-text');
    if(savedText){
        element.disabled = false;
        element.innerText= savedText;
        element.removeAttribute('data-text');
    }else{
        element.style.display = "none";
    }
}

function showOverlaySpinner(elem, opts){
    const width = 50;
    const height = 50;
    const left = (elem.offsetWidth - width) / 2 + (opts.xOffset || 0);
    const top = (elem.offsetHeight - height) / 2 + (opts.yOffset || 0);

    const div = document.createElement('div');
    const style = 'position: relative; z-index:99999; left:' + left + 'px; top:' + top + 'px; width:' + width + 'px; height:' + height + 'px;background-color:#fff';
    div.setAttribute('style', style);    
    div.setAttribute('class', 'px-widget');

    ReactDOM.render(<div className="progress-circle progress-indeterminate dls-accent-white-01-bg"></div>, div);
    elem.parentElement.insertBefore(div, elem);

    return div;
}


function showEmbeddedSpinner(element){
    var height = element.style.height;
    element.setAttribute('data-text', element.innerText);
    element.innerHTML=`<div class="progress-circle progress-indeterminate progress-sm"></div>`;
    element.style.height = height; // keep the old size
}

export const spinnerStyles = "#spinner {display: -webkit-inline-box;display: -ms-inline-flexbox;display: inline-flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center;position: relative;width: 100%;height: 100vh;-webkit-transition: none;transition: none;}#spinner:before{position: absolute;left:50%;display: block;content: '';border-style: solid;border-color: rgba(204, 204, 204, 0.25);border-left-color: #1274b8;-webkit-transform: translateZ(0);transform: translateZ(0);border-radius: 50%;width: 50px;height: 50px;border-width: 4px;will-change: transform;-webkit-animation: spinner-indeterminate 0.8s linear infinite;animation: spinner-indeterminate 0.8s linear infinite;}@-webkit-keyframes spinner-indeterminate {0% {-webkit-transform: rotate(0deg);transform: rotate(0deg);}100% {-webkit-transform: rotate(360deg);transform: rotate(360deg);}}@keyframes spinner-indeterminate {0% {-webkit-transform: rotate(0deg);transform: rotate(0deg);}100% {-webkit-transform: rotate(360deg);transform: rotate(360deg);}}"


// WEBPACK FOOTER //
// ./application/src/views/comps/spinner.jsx